import { CancelPolicyConfirmationPlanDetails } from "./components/CancelPolicyConfirmationPlanDetails";
import { CancelPolicyDesktopPageHeader } from "./components/CancelPolicyDesktopPageHeader";
import { CancelPolicyManageInsurance } from "./components/CancelPolicyManageInsurance";
import { CancelPolicyOrderSummary } from "./components/CancelPolicyOrderSummary";
import { CancelPolicyPaymentDetails } from "./components/CancelPolicyPaymentDetails";
import { CancelPolicyReasonSelector } from "./components/CancelPolicyReasonSelector";
import { CancelPolicyRefundBreakup } from "./components/CancelPolicyRefundBreakup";
import { CancelPolicyRefundModeSelector } from "./components/CancelPolicyRefundModeSelector";
import { CancelPolicySupportInfo } from "./components/CancelPolicySupportInfo";

export const CANCEL_POLICY_COMPONENT_MAPPER = {
  top: {
    COMPONENT_CANCELLATION_PAGE_HEADER: CancelPolicyDesktopPageHeader,
  },
  left: {
    COMPONENT_CANCELLATION_REFUND_BREAKUP: CancelPolicyRefundBreakup,
    COMPONENT_CANCELLATION_REASON_SELECTOR: CancelPolicyReasonSelector,
    COMPONENT_CANCELLATION_REFUND_MODE_SELECTOR: CancelPolicyRefundModeSelector,
    COMPONENT_CANCELLATION_CONFIRMATION_PLAN_DETAILS:
      CancelPolicyConfirmationPlanDetails,
  },
  right: {
    COMPONENT_CANCELLATION_ORDER_SUMMARY: CancelPolicyOrderSummary,
    COMPONENT_CANCELLATION_PAYMENT_DETAILS: CancelPolicyPaymentDetails,
    COMPONENT_CANCELLATION_SUPPORT_INFO: CancelPolicySupportInfo,
    COMPONENT_CANCELLATION_MANAGE_INSURANCE: CancelPolicyManageInsurance,
  },
} as const;
